import { refreshToken } from "./modules/authWelly";

export default {
  install(Vue) {
    Vue.prototype.$refreshToken = refreshToken;
    refreshToken()
  }
}